import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { Button, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { injectModels } from "../../../redux/injectModels";

import { TraderUnitService } from "../../../services";
import { toast } from "react-toastify";
import html2pdf from "html2pdf.js";

import { handleConsoleError } from "../../../utils/common-methods";

const TraderUnitDocument = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  //const [TraderUnitID, setTraderUnitID] = useState("");
  const navigate = useNavigate();

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  // const TraderUnitId = TraderUnitService.getSelectedTraderUnit();
  const { unitId } = useParams();

  useEffect(() => {
    getData(unitId);
  }, []);

  // TraderUnit Document List
  const getData = async (TraderUnitId) => {
    props.application.setLoading(true);
    try {
      const res = await TraderUnitService.getDocumentByTraderUnitId(
        TraderUnitId
      );
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        setFilteredData([]);
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  const handleEdit = async (id) => {
    try {
      // TraderUnitService.setDocumentId(id);
      navigate(
        routes.TRADER_UNIT_CREATE_DOCUMENT.replace(":unitId", unitId).replace(
          ":documentId",
          id
        )
      );
    } catch (error) {
      // props.application.setLoading(false);
      // toast.error("Something went wrong");
    }
  };

  const handleCreateDoc = async () => {
    //TraderUnitService.removeDocumentId(); //change
    try {
      navigate(
        routes.TRADER_UNIT_CREATE_DOCUMENT.replace(":unitId", unitId).replace(
          ":documentId",
          "create"
        )
      );
    } catch (error) {
      // props.application.setLoading(false);
      // toast.error("Something went wrong");
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record?"
    );

    if (!confirmDelete) {
      return; // Exit if the user cancels
    }

    try {
      props.application.setLoading(true);
      const response = await TraderUnitService.deleteTraderUnitDocument(id);
      if (response?.isSuccess) {
        toast.success("Record deleted successfully");
        await getData(unitId);
        props.application.setLoading(false);
      } else {
        toast.error(response?.message || "Failed to delete the record");
      }
    } catch (error) {
      toast.error(
        error?.message || "An error occurred while deleting the record"
      );
    } finally {
      props.application.setLoading(false);
    }
  };

  const handleGeneratePDF = async () => {
    // Path to your HTML file
    const pdfHtmlPath = "/assets/invoice.html"; // Adjust this based on your folder structure

    try {
      // Fetch the HTML content
      const response = await fetch(pdfHtmlPath);
      const htmlContent = await response?.text();

      // Create a container to hold the HTML content
      const tempContainer = document.createElement("div");
      tempContainer.innerHTML = htmlContent;
      document.body.appendChild(tempContainer);

      // Generate the PDF
      const options = {
        margin: 1,
        filename: "GeneratedPDF.pdf",
        html2canvas: { scale: 2 }, // High-quality rendering
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };

      html2pdf()
        .set(options)
        .from(tempContainer)
        .save();

      // Clean up the temporary container
      document.body.removeChild(tempContainer);
    } catch (error) {    
      const message= handleConsoleError(error,"Error generating PDF:");
       toast.error(error?.message|| message);
    }
  };

  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="container">
          <div className="verifier-buttton">
            <Button
              onClick={(e) => {
                e.preventDefault();
                handleCreateDoc();
              }}
            >
              Create New Document
            </Button>{" "}
          </div>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  {/* <th>TraderUnit Name</th> */}
                  <th>Name</th>
                  <th>Document Type</th>
                  <th>Document</th>
                  {/* <th>Status</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.documentName}</td>
                          <td>{item?.documentsTypeName}</td>
                          <td>
                            {item?.documentFileURL && (
                              <a
                                href={item?.documentFileURL}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {item?.documentFile}
                              </a>
                            )}
                          </td>
                          {/* <td>
                            {item.isActive === true ? (
                              <i className="ri-check-fill"></i>
                            ) : (
                              <i className="ri-close-circle-line"></i>
                            )}
                          </td> */}
                          <td>
                            <div className="delete-create">
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEdit(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-pencil-line"></i>
                              </Link>

                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDelete(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-delete-bin-line"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>

        {/* <div
          ref={pdfContentRef}
          // style={{ display: "none" }}
          dangerouslySetInnerHTML={{ __html: pdfHtmlContent }}
        /> */}
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(TraderUnitDocument);
